module.exports = __webpack_public_path__ + "img/ZhangChaolin.48ac256a.png";